/**
 * Provided as a catch all and ideally shouldn't be thrown
 */
export default class UnknownAppError extends Error {
  constructor(message) {
    super(message || 'Caught an unhandled client side error')
    this.name = 'UnknownAppError'
  }
}
